import axios, { AxiosResponse } from 'axios'
import { IFetchEvolutionReportUrlParams, IEvolutionReportUrl } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: apiUrl } = process.env

export const fetchEvolutionReportUrl = async (params: IFetchEvolutionReportUrlParams): Promise<IEvolutionReportUrl> => {
  const response = await axios.post(`${apiUrl}/mount-evolutionary-report-url`, params)
  const { data }: AxiosResponse<IEvolutionReportUrl> = response
  return data
}
